module.exports = __webpack_public_path__ + "static/media/view.47616a5a.svg";